import DepartureCertificationModal from '@/components/MedicalDepartureWifi/DepartureCertificationModal';
import Step2 from '@/components/MedicalDepartureWifi/Step2';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

function MedicalKorDepartureStep2() {
  const history = useHistory();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const onCloseModal = () => {
    setIsOpenModal(false);
    history.push('/home');
  };

  return (
    <>
      <Step2 isDetailStep />
      <Button onClick={() => setIsOpenModal(true)}>출국 인증하기</Button>
      {isOpenModal && <DepartureCertificationModal onClose={onCloseModal} />}
    </>
  );
}

const Button = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #246cf6;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  box-shadow: 0px 4px 12px 0px #1919192e;
  margin-top: 48px;
`;

export default MedicalKorDepartureStep2;
